import { render } from "./actionsDialog.vue?vue&type=template&id=fdfdd570"
import script from "./actionsDialog.vue?vue&type=script&lang=js"
export * from "./actionsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__